import { VFC } from 'react';

import AttributeItem, { AttributeGrid } from 'dashboard/components/AttributeItem';
import { ReportMiddeskBusinessLookup } from 'dashboard/models/report/integration/middesk-business-lookup';

interface ReportMiddeskBusinessLookupProps {
  report: ReportMiddeskBusinessLookup;
  isRedacted: boolean;
}

const MiddeskBusinessLookup: VFC<ReportMiddeskBusinessLookupProps> = ({
  report,
  isRedacted,
}: ReportMiddeskBusinessLookupProps) => {
  return (
    <AttributeGrid>
      <AttributeItem
        title='Business Name'
        value={report.attributes.query?.['business-name']}
        placeholder='N/A'
        isRedacted={isRedacted}
        dataTest='report-middesk-business-lookup__business-name'
      />
      <AttributeItem
        title='Address'
        value={
          <p>
            {report.attributes.query?.['address-street-1']}
            <br />
            {report.attributes.query?.['address-street-2']} && (
            <>
              {report.attributes.query?.['address-street-2']} <br />
            </>
            ){report.attributes.query?.['address-city']},{' '}
            {report.attributes.query?.['address-subdivision']},{' '}
            {report.attributes.query?.['address-postal-code']}
          </p>
        }
        placeholder='N/A'
        isRedacted={isRedacted}
        dataTest='report-middesk-business-lookup__address'
      />
      {report.attributes.query?.['phone-number'] && (
        <AttributeItem
          title='Phone Number'
          value={report.attributes.query?.['phone-number']}
          placeholder='N/A'
          isRedacted={isRedacted}
          dataTest='report-middesk-business-lookup__phone-number'
        />
      )}
      {report.attributes.query?.['tin'] && (
        <AttributeItem
          title='TIN'
          value={report.attributes.query?.['tin']}
          placeholder='N/A'
          isRedacted={isRedacted}
          dataTest='report-middesk-business-lookup__tin'
        />
      )}
      {report.attributes.query?.['website'] && (
        <AttributeItem
          title='Website'
          value={report.attributes.query?.['website']}
          placeholder='N/A'
          isRedacted={isRedacted}
          dataTest='report-middesk-business-lookup__website'
        />
      )}
    </AttributeGrid>
  );
};

export default MiddeskBusinessLookup;
